module.exports = __webpack_public_path__ + "img/body-3-lg.aad417e0.png";